var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutGrid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 397,
    height: 354,
    viewBox: "0 0 397 354",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24826",
    "data-name": "Group 24826",
    transform: "translate(14.73 -161.996)",
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    transform: "translate(73.27 161.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-2",
    "data-name": "Rectangle 11",
    transform: "translate(117.27 161.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-3",
    "data-name": "Rectangle 11",
    transform: "translate(161.27 161.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 44.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-4",
    "data-name": "Rectangle 11",
    transform: "translate(206.27 161.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-5",
    "data-name": "Rectangle 11",
    transform: "translate(250.27 161.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-6",
    "data-name": "Rectangle 11",
    transform: "translate(294.27 161.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-7",
    "data-name": "Rectangle 11",
    transform: "translate(338.27 161.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-8",
    "data-name": "Rectangle 11",
    transform: "translate(73.27 205.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 44.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-9",
    "data-name": "Rectangle 11",
    transform: "translate(117.27 205.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 44.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-10",
    "data-name": "Rectangle 11",
    transform: "translate(161.27 205.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 44.7,
    height: 44.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-11",
    "data-name": "Rectangle 11",
    transform: "translate(206.27 205.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 44.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-12",
    "data-name": "Rectangle 11",
    transform: "translate(250.27 205.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 44.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-13",
    "data-name": "Rectangle 11",
    transform: "translate(294.27 205.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 44.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-14",
    "data-name": "Rectangle 11",
    transform: "translate(338.27 205.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 44.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-15",
    "data-name": "Rectangle 11",
    transform: "translate(73.27 250.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 43,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 42.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-16",
    "data-name": "Rectangle 11",
    transform: "translate(117.27 250.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 43,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 42.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-17",
    "data-name": "Rectangle 11",
    transform: "translate(161.27 250.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 43,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 44.7,
    height: 42.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-18",
    "data-name": "Rectangle 11",
    transform: "translate(206.27 250.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 43,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 42.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-19",
    "data-name": "Rectangle 11",
    transform: "translate(250.27 250.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 43,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 42.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-20",
    "data-name": "Rectangle 11",
    transform: "translate(294.27 250.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 43,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 42.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-21",
    "data-name": "Rectangle 11",
    transform: "translate(338.27 250.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 43,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 42.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-22",
    "data-name": "Rectangle 11",
    transform: "translate(73.27 293.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 44.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-23",
    "data-name": "Rectangle 11",
    transform: "translate(117.27 293.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 44.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-24",
    "data-name": "Rectangle 11",
    transform: "translate(161.27 293.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 44.7,
    height: 44.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-25",
    "data-name": "Rectangle 11",
    transform: "translate(206.27 293.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 44.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-26",
    "data-name": "Rectangle 11",
    transform: "translate(250.27 293.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 44.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-27",
    "data-name": "Rectangle 11",
    transform: "translate(294.27 293.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 44.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-28",
    "data-name": "Rectangle 11",
    transform: "translate(338.27 293.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 44.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-29",
    "data-name": "Rectangle 11",
    transform: "translate(73.27 338.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-30",
    "data-name": "Rectangle 11",
    transform: "translate(117.27 338.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-31",
    "data-name": "Rectangle 11",
    transform: "translate(161.27 338.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 44.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-32",
    "data-name": "Rectangle 11",
    transform: "translate(206.27 338.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-33",
    "data-name": "Rectangle 11",
    transform: "translate(250.27 338.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-34",
    "data-name": "Rectangle 11",
    transform: "translate(294.27 338.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-35",
    "data-name": "Rectangle 11",
    transform: "translate(338.27 338.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-36",
    "data-name": "Rectangle 11",
    transform: "translate(73.27 382.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-37",
    "data-name": "Rectangle 11",
    transform: "translate(117.27 382.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-38",
    "data-name": "Rectangle 11",
    transform: "translate(161.27 382.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 44.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-39",
    "data-name": "Rectangle 11",
    transform: "translate(206.27 382.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-40",
    "data-name": "Rectangle 11",
    transform: "translate(250.27 382.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-41",
    "data-name": "Rectangle 11",
    transform: "translate(294.27 382.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-42",
    "data-name": "Rectangle 11",
    transform: "translate(338.27 382.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-43",
    "data-name": "Rectangle 11",
    transform: "translate(73.27 426.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 44.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-44",
    "data-name": "Rectangle 11",
    transform: "translate(117.27 426.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 44.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-45",
    "data-name": "Rectangle 11",
    transform: "translate(161.27 426.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 44.7,
    height: 44.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-46",
    "data-name": "Rectangle 11",
    transform: "translate(206.27 426.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 44.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-47",
    "data-name": "Rectangle 11",
    transform: "translate(250.27 426.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 44.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-48",
    "data-name": "Rectangle 11",
    transform: "translate(294.27 426.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 44.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-49",
    "data-name": "Rectangle 11",
    transform: "translate(338.27 426.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 44.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24827",
    "data-name": "Group 24827"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-50",
    "data-name": "Rectangle 11",
    transform: "translate(29.27 161.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-51",
    "data-name": "Rectangle 11",
    transform: "translate(29.27 205.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 44.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-52",
    "data-name": "Rectangle 11",
    transform: "translate(29.27 250.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 43,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 42.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-53",
    "data-name": "Rectangle 11",
    transform: "translate(29.27 293.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 44.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-54",
    "data-name": "Rectangle 11",
    transform: "translate(29.27 338.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-55",
    "data-name": "Rectangle 11",
    transform: "translate(29.27 382.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-56",
    "data-name": "Rectangle 11",
    transform: "translate(29.27 426.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 44.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-57",
    "data-name": "Rectangle 11",
    transform: "translate(29.27 471.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24828",
    "data-name": "Group 24828",
    transform: "translate(-44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-58",
    "data-name": "Rectangle 11",
    transform: "translate(29.27 161.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-59",
    "data-name": "Rectangle 11",
    transform: "translate(29.27 205.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 44.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-60",
    "data-name": "Rectangle 11",
    transform: "translate(29.27 250.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 43,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 42.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-61",
    "data-name": "Rectangle 11",
    transform: "translate(29.27 293.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 44.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-62",
    "data-name": "Rectangle 11",
    transform: "translate(29.27 338.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-63",
    "data-name": "Rectangle 11",
    transform: "translate(29.27 382.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-64",
    "data-name": "Rectangle 11",
    transform: "translate(29.27 426.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 44.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-65",
    "data-name": "Rectangle 11",
    transform: "translate(29.27 471.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-66",
    "data-name": "Rectangle 11",
    transform: "translate(73.27 471.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-67",
    "data-name": "Rectangle 11",
    transform: "translate(117.27 471.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-68",
    "data-name": "Rectangle 11",
    transform: "translate(161.27 471.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 44.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-69",
    "data-name": "Rectangle 11",
    transform: "translate(206.27 471.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-70",
    "data-name": "Rectangle 11",
    transform: "translate(250.27 471.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-71",
    "data-name": "Rectangle 11",
    transform: "translate(294.27 471.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11-72",
    "data-name": "Rectangle 11",
    transform: "translate(338.27 471.996)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 43.7,
    height: 43.7,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutGrid);
export default __webpack_public_path__ + "static/media/aboutGrid.6f97bdea209da36f84ddeb73bd5f0b82.svg";
export { ForwardRef as ReactComponent };